/* ############################################## */
/* CE_MENU-ITEM */
/* ############################################## */
$(document).ready(function(){
    $('body').scrollspy({target: ".main-nav", offset: 100});
});

/* ContentElement: MenuItem - for creating a menu */
var menuheaderentries = '';
var tmp = document.querySelectorAll('.menuitem');
for (var i = 0; i < tmp.length; i++) {
    menuheaderentries = menuheaderentries + '<li><a href="#' + tmp[i].id + '" id="' + tmp[i].id + '_menu">' + tmp[i].dataset['title'] + '</a></li>';
}
if (menuheaderentries.length > 0) {
    var element = document.querySelector('.main-nav .pagemenu');
    element.innerHTML = element.innerHTML + menuheaderentries;
}


function highlightCurrentNavElement(element) {
    document.getElementById(element.id + '_menu').classList.add('active');
}

function removeCurrentNavElement(element) {
    document.getElementById(element.id + '_menu').classList.remove('active');
}



/* ############################################## */
/* CE_PORTFOLIO-FILTER */
/* ############################################## */
function showOnlyClassFilter(className) {
    document.querySelector('.ce_portfolio-filter').scrollIntoView();
    $('.item').show();
    if(className !== '') {
        $('.item').hide();
        $('.item.' + className).show();
    }
    document.querySelector('.filter .btn.active').classList.remove('active');

    if (className == '') {
        document.querySelector('.filter .btn.all').classList.add('active');
    } else {
        document.querySelector('.filter .btn.' + className).classList.add('active');

    }
}

